const Assets = {
  JoinDialogAssets: {
    camOnIcon: "assets/components/JoinDialog/CamIconOn.svg",
    camOffIcon: "assets/components/JoinDialog/CamIconOff.svg",
    micOnIcon: "assets/components/JoinDialog/MicIconOn.svg",
    micOffIcon: "assets/components/JoinDialog/MicIconOff.svg",
  },
  Whiteboard: {
    Toolbar: {
      rectangleIcon: "assets/components/Whiteboard/Toolbar/Rectangle.svg",
      dotLineIcon: "assets/components/Whiteboard/Toolbar/DotLine.svg",
      arrowIcon: "assets/components/Whiteboard/Toolbar/Arrow.svg",
      boldLineIcon: "assets/components/Whiteboard/Toolbar/BoldLine.svg",
      lineIcon: "assets/components/Whiteboard/Toolbar/Line.svg",
      clearBoardIcon: "assets/components/Whiteboard/Toolbar/ClearBoard.svg",
      saveBoardIcon: "assets/components/Whiteboard/Toolbar/SaveBoard.svg",
      triangleDownIcon: "assets/components/Whiteboard/Toolbar/TriangleDown.svg",
      penIcon: "assets/components/Whiteboard/Toolbar/Pen.svg",
      selectIcon: "assets/components/Whiteboard/Toolbar/Select.svg",
      ellipseIcon: "assets/components/Whiteboard/Toolbar/Ellipse.svg",
      triangleIcon: "assets/components/Whiteboard/Toolbar/Triangle.svg",
      brushIcon: "assets/components/Whiteboard/Toolbar/Brush.svg",
      textIcon: "assets/components/Whiteboard/Toolbar/Text.svg",
      eraser1Icon: "assets/components/Whiteboard/Toolbar/Eraser1.svg",
      circleIcon: "assets/components/Whiteboard/Toolbar/Circle.svg",
    },
  },
  MeetingDrawer: {
    ParticipantList: {
      pinIcon: "assets/components/MeetingDrawer/ParticipantList/Pin.svg",
      unpinIcon: "assets/components/MeetingDrawer/ParticipantList/Unpin.svg",
    },
  },
  Containers: {
    pinIcon: "assets/components/Containers/Pin.svg",
  },
  Interpreter: {
    flagTurkish: "assets/components/Interpreter/TurkishFlag.svg",
    flagEnglish: "assets/components/Interpreter/EnglishFlag.svg",
    flagBengali: "assets/components/Interpreter/BengaliFlag.svg",
    translateBadgeBlack:
      "assets/components/Interpreter/TranslateBadgeBlack.svg",
    translateBadgeWhite:
      "assets/components/Interpreter/TranslateBadgeWhite.svg",
    translationArrow: "assets/components/Interpreter/TranslationArrow.svg",
    translationDirectionLine:
      "assets/components/Interpreter/TranslationDirectionLine.svg",
    translationFlag: "assets/components/Interpreter/TranslationFlag.svg",
  },
};
export default Assets;
